<mat-divider class="pb-24"></mat-divider>
<div class="table-wrapper">
  <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef> First Name </th>
      <td mat-cell *matCellDef="let customer"> {{ customer.customerUser.firstName }} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let customer"> {{ customer.customerUser.emailId }} </td>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef> Company </th>
      <td mat-cell *matCellDef="let customer"> {{ getFullCompanyLine(customer) }} </td>
    </ng-container>

    <ng-container matColumnDef="lastSignInAt">
      <th mat-header-cell *matHeaderCellDef> Last Sign In </th>
      <td mat-cell *matCellDef="let customer"> {{ formatDate(customer.customerUser.lastSignInAt) }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
